import React from "react";

const cardStyle: React.CSSProperties = {
  background: "#ffffff",
  border: "1px solid #e5e7eb",
  borderRadius: 18,
  padding: "1rem",
};

const reviews = [
  {
    id: "rev-1",
    customer: "Maya",
    rating: 5,
    review: "Great service and clean studio setup.",
    response: "",
  },
  {
    id: "rev-2",
    customer: "Rohan",
    rating: 4,
    review: "Good experience, a little delay at the start.",
    response: "Thanks for the feedback. We are improving our slot timing.",
  },
];

export default function ProviderReviewsPage() {
  return (
    <div style={{ display: "grid", gap: "1rem" }}>
      <section style={cardStyle}>
        <h2 style={{ margin: 0, color: "#0f172a" }}>Reviews</h2>
        <p style={{ margin: "0.5rem 0 0", color: "#475569", lineHeight: 1.7 }}>
          Review customer feedback and draft provider responses.
        </p>
      </section>

      {reviews.map((item) => (
        <section key={item.id} style={cardStyle}>
          <div style={{ color: "#0f172a", fontWeight: 700 }}>
            {item.customer} · {item.rating}/5
          </div>
          <p style={{ margin: "0.55rem 0 0", color: "#334155", lineHeight: 1.7 }}>
            {item.review}
          </p>
          <p style={{ margin: "0.55rem 0 0", color: "#64748b", lineHeight: 1.7 }}>
            {item.response ? `Response: ${item.response}` : "No response drafted yet."}
          </p>
        </section>
      ))}
    </div>
  );
}